module.exports = __webpack_public_path__ + "static/media/4.5a1ca972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/soligorsk/4.jpg
// module id = 543
// module chunks = 0